// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yxyweb/client/styles/default/button.less
// module id = 3216
// module chunks = 0